import { isNil } from 'lodash'
import { CountryCode } from './debtorModels'
import { isEmptyString } from '../utils/stringUtils'

export type Address = {
    first: string
    second?: string
    city: string
    region?: string
    postal: string
    country: CountryCode
}

export function sanitizeAddress(address: Address | undefined | null): Address | undefined {
    if (
        isNil(address) ||
        (isEmptyString(address.country) &&
            isEmptyString(address.city) &&
            isEmptyString(address.first) &&
            isEmptyString(address.postal))
    )
        return undefined

    return {
        first: address.first.trim(),
        city: address.city.trim(),
        postal: address.postal.trim(),
        country: address.country.trim() as CountryCode,
        second: address.second?.trim() || undefined,
        region: address.region?.trim() || undefined
    }
}
